<template>
  <div>
    <template>
      <!---Slider Ends-->
      <!---English Slider Start-->
      <section class="section-banner ">
        <div class="slider-wrapper" v-if="langName != 'ar'">
          <div class="slider-track" :style="sliderStyle">
            <div
              class="slider-image"
              v-for="(banner, index) in englishBannerData"
              :key="index"
            >
              <a
                :href="!isUPPLoyaltySubscribe ? `/LoyaltyHowItWorks` : ''"
                target="_blank"
              >
                <img
                  v-if="banner.mobile_banner_image_url"
                  :src="banner.mobile_banner_image_url"
                  class="img-fluid aspect_mob d-block d-md-none w-100"
                />
                <img
                  v-if="banner.banner_image_url"
                  :src="banner.banner_image_url"
                  class="img-fluid responsive_width d-none d-md-block"
                />
              </a>
            </div>
          </div>

          <!-- <div class="slider-controls">
            <button @click="prevSlide">‹</button>
            <button @click="nextSlide">›</button>
          </div> -->

          <div class="slider-dots">
            <span
              v-for="(banner, index) in englishBannerData"
              :key="index"
              :class="{ active: index === currentIndex }"
              @click="goToSlide(index)"
            ></span>
          </div>
        </div>
        <!---English Slider Ends-->
        <!---Arabic Slider Start-->
        <div class="slider-wrapper" v-if="langName == 'ar'">
          <div class="slider-track" :style="sliderStyle">
            <div
              class="slider-image"
              v-for="(banner, index) in arabicBannerData"
              :key="index"
            >
              <a
                :href="!isUPPLoyaltySubscribe ? `/LoyaltyHowItWorks` : ''"
                target="_blank"
              >
                <img
                  v-if="banner.mobile_banner_image_url"
                  :src="banner.mobile_banner_image_url"
                  class="img-fluid aspect_mob d-block d-md-none w-100"
                />
                <img
                  v-if="banner.banner_image_url"
                  :src="banner.banner_image_url"
                  class="img-fluid responsive_width d-none d-md-block"
                />
              </a>
            </div>
          </div>

          <!-- <div class="slider-controls">
            <button @click="prevSlide">‹</button>
            <button @click="nextSlide">›</button>
          </div> -->

          <div class="slider-dots">
            <span
              v-for="(banner, index) in arabicBannerData"
              :key="index"
              :class="{ active: index === currentIndex }"
              @click="goToSlide(index)"
            ></span>
          </div>
        </div>

        <!---Arabic Slider Ends-->
      </section>

      <!---Slider Ends-->

      <!---Slider Ends-->
    </template>
    <div class="px-lg-0 pt-lg-3 my-xl-2 club_empire_main_wrapper">
      <div class="cinema-accordion offer-accordion my-4">
        <div v-b-toggle.menu-1 variant="info" class="accordion-title">
          <div class="main-heading">
            <div>
              <hr class="primary-line" />
            </div>
            <div class="title">
              {{ allLanguageData.Loyalty.welcome_to_title }}
            </div>

            <!-- <div class="content-desc">
            {{ allLanguageData.Loyalty[1].welcomeTo }}
          </div> -->
            <!-- <div class="sub-titles pl-1">LOCATION</div> -->
          </div>

          <!-- welcome_to_title -->
          <p class="content-title my-3 font-weight-bold">
            {{ allLanguageData.Loyalty.welcomeTo }}
          </p>

          <!-- <p class="content-title my-3">{{ allLanguageData.Loyalty.embark }}</p> -->
          <p class="content-title my-3" v-html="localizedEmbarkText"></p>

          <p class="content-title my-3">
            {{ allLanguageData.Loyalty.customerCan }}
            <a
              href="https://apps.apple.com/in/app/empire-cinemas/id1459864736"
              style="color: red"
              >{{ allLanguageData.Loyalty.IOS }}</a
            >
            {{ allLanguageData.Loyalty.and }}
            <a
              href="https://play.google.com/store/apps/details?id=com.binary.empirecinema&hl=en"
              style="color: red"
              >{{ allLanguageData.Loyalty.Android }}</a
            >
            {{ langName === "eng" ? allLanguageData.Loyalty.users : "" }}.
          </p>

          <div class="main-heading">
            <div>
              <hr class="primary-line" />
            </div>
            <div class="title">{{ allLanguageData.Loyalty.getreward }}</div>
          </div>

          <p class="content-title my-3">
            {{ allLanguageData.Loyalty.empireLoyalty }}
          </p>

          <p class="content-title my-3">
            {{ allLanguageData.Loyalty.theprogramconsists }}
          </p>

          <p class="content-title my-3">
            {{ allLanguageData.Loyalty.thecashback }}
          </p>

          <div class="main-heading">
            <div>
              <hr class="primary-line" />
            </div>
            <div class="title">{{ allLanguageData.Loyalty.stampsReward }}</div>
          </div>

          <!-- <p class="content-title my-3">
            {{ allLanguageData.Loyalty.aftersix }}
          </p> -->
          <p
            class="content-title my-3"
            v-html="formatCurrencyText(allLanguageData.Loyalty.aftersix)"
          ></p>

          <p class="content-title my-3">
            {{ allLanguageData.Loyalty.ifyouAre }}
          </p>

          <div
            class="club_content_wrapper align-items-center text-center"
            id="content_parent"
          >
            <div class="d-block">
              <img src="@/assets/img/icons-01.png" class="icons_img" />

              <h6 class="font-weight-bold text-capitalize">
                {{ allLanguageData.Loyalty.create_account }}
              </h6>

              <p>
                {{ allLanguageData.Loyalty.to_get_started }}
                <router-link to="/LoyaltyHowItWorks" style="color: #ce1f2e"
                  >{{ allLanguageData.Loyalty.join_now }}.</router-link
                >{{ allLanguageData.Loyalty.you_can_also }}
                <router-link to="/getApp" style="color: #ce1f2e">{{
                  allLanguageData.Loyalty.join_in_app
                }}</router-link
                >&nbsp;{{ allLanguageData.Loyalty.at_the_branch }}
              </p>
            </div>

            <img src="@/assets/img/icons-02.png" class="icons_img mob_rotate" />

            <div class="d-block">
              <img src="@/assets/img/icons-03.png" class="icons_img" />

              <h6 class="font-weight-bold text-capitalize">
                {{ allLanguageData.Loyalty.order_pay }}
              </h6>

              <p>
                {{ allLanguageData.Loyalty.use_cash }}
                <!-- <router-link
                  to="/clubEmpire"
                  style="color:#ce1f2e;white-space: nowrap;"
                  >{{ allLanguageData.Loyalty.learn_how }}.</router-link
                > -->
              </p>
            </div>

            <img src="@/assets/img/icons-02.png" class="icons_img mob_rotate" />

            <div class="d-block">
              <img src="@/assets/img/icons-04.png" class="icons_img" />

              <h6 class="font-weight-bold text-capitalize">
                {{ allLanguageData.Loyalty.collect_points }}
              </h6>

              <!-- <p>
                {{ allLanguageData.Loyalty.as_you_earn }}
                {{ allLanguageData.Loyalty.for_every_online }}
              </p> -->
              <p v-html="formattedCombinedText"></p>
            </div>
          </div>
          <!-- <div class="main-heading">
          <div>
            <hr class="primary-line" />
          </div>
          <div class="title"> {{ allLanguageData.Loyalty.singUpToEnjoy }}</div>
        </div> -->

          <!---User Form To Subscribe For Loyalty Start-->
          <!-- <LoyaltyForm /> -->
          <!---User Form To Subscribe For Loyalty End-->

          <div class="join_us_wrapper" v-if="!isUPPLoyaltySubscribe">
            <router-link
              :to="!loggedInFlag ? '/login' : '/LoyaltyHowItWorks'"
              style="color: #000"
            >
              <button class="" style="cursor: pointer">
                {{ allLanguageData.Loyalty.join_us }}
              </button></router-link
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
import LoyaltyForm from "@/components/pages/loyaltyForm.vue";
import { makeRequest, makeRequestBrij } from "@/helper/internet.js";
import { IMG_BASEURL } from "@/config/index";
export default {
  components: {
    LoyaltyForm,
  },
  data() {
    return {
      currentIndex: 0,
      autoPlayInterval: null,
      loggedInFlag: false,
      IMG_BASEURL: IMG_BASEURL,
      bannerSlider: {
        autoplay: true,
        autoplaySpeed: 2000,
        arrows: false,
        dots: false,
        infinite: true,
        slidesToScroll: 1,
        slidesToShow: 1,
      },
      englishBannerData: [],
      arabicBannerData: [],
      errorMessage: "",
      sectionCollapse: {
        RedBenefits: true,
        GoldBenefits: true,
      },
      isUPPLoyaltySubscribe: false,
    };
  },
  computed: {
    localizedEmbarkText() {
      return this.allLanguageData.Loyalty.embark.replace(
        "SAR",
        '<span class="sar-symbol" style="font-size:16px">&#xe900;</span>'
      );
    },
    formattedCombinedText() {
      const combinedText = `${this.allLanguageData.Loyalty.as_you_earn} ${
        this.allLanguageData.Loyalty.for_every_online
      }`;
      return this.formatCurrencyText(combinedText);
    },
    sliderStyle() {
      return {
        transform:
          this.langName == "ar"
            ? `translateX(+${this.currentIndex * 100}%)`
            : `translateX(-${this.currentIndex * 100}%)`,
      };
    },
  },
  mounted() {
    this.startAutoPlay();
  },
  beforeDestroy() {
    clearInterval(this.autoPlayInterval);
  },
  beforeMount() {
    $(document).ready(function() {
      if ($("body").hasClass("rtl-class")) {
        $("p").addClass("text-right");
        $("#content_parent").addClass("flex-row-reverse");
      } else {
        $("p").removeClass("text-right");
        $("#content_parent").removeClass("flex-row-reverse");
      }
    });
    this.getClubBanner();
    let profile_detail = JSON.parse(localStorage.getItem("profile_detail"));

    if (profile_detail) {
      this.loggedInFlag = true;
      this.isUPPLoyaltySubscribe = profile_detail.upp_loyalty_balance > 0;
    }

    // this.isUPPLoyaltySubscribe = localStorage.getItem("isUPPLoyaltySubscribe");
  },
  methods: {
    formatCurrencyText(text) {
      return text.replace(
        /SAR/g,
        '<span class="sar-symbol" style="font-size:16px">&#xe900;</span>'
      );
    },
    startAutoPlay() {
      this.autoPlayInterval = setInterval(this.nextSlide, 4000);
    },
    nextSlide() {
      if (this.englishBannerData.length > 0) {
        this.currentIndex =
          (this.currentIndex + 1) % this.englishBannerData.length;
      } else if (this.langName == "ar" && this.arabicBannerData.length > 0) {
        this.currentIndex =
          (this.currentIndex + 1) % this.arabicBannerData.length;
      }
    },
    prevSlide() {
      if (this.englishBannerData.length > 0) {
        this.currentIndex =
          (this.currentIndex + 1) % this.englishBannerData.length;
      } else if (this.langName == "ar" && this.arabicBannerData.length > 0) {
        this.currentIndex =
          (this.currentIndex + 1) % this.arabicBannerData.length;
      }
    },
    goToSlide(index) {
      this.currentIndex = index;
    },
    getClubBanner() {
      let payload = {};

      try {
        let cinema = JSON.parse(localStorage.getItem(`brij_cinema`));
        if (cinema) payload.cinema_id = cinema.cinema_id;
      } catch (e) {}
      makeRequestBrij(`/api/cinema/clubEmpireBanners`, "GET", null, payload)
        .then((response) => {
          this.showLoading();
          //console.log("responseeee :", response);
          const { error, res } = response;
          if (!error && res.data.status) {
            this.hideLoading();
            this.arabicBannerData = res.data.ArabicArrBanner;
            this.englishBannerData = res.data.EnglishArrBanner;

            // console.log(
            //   this.checkBaseUrl(
            //     this.englishBannerData[0].mobile_banner_image_url
            //   ),
            //   "this.englishBannerData[0].mobile_banner_image_url"
            // );
          } else {
            this.hideLoading();
            this.errorMessage = res.data.message;
          }
        })
        .catch((error) => {
          this.hideLoading();
          console.log("Error", error);
          //   resolve(null);
        });
    },
  },
};
</script>
<style scoped>
.slider-wrapper {
  position: relative;
  overflow: hidden;
  width: 100%;
  max-width: 100%;
  margin: 0px;
}

.slider-track {
  display: flex;
  transition: transform 0.5s ease-in-out;
  width: 100%;
}

.slider-image {
  min-width: 100%;
  box-sizing: border-box;
}
.slider-image img {
  width: 100%;
}
.slider-controls {
  position: absolute;
  top: 50%;
  width: 100%;
  display: flex;
  justify-content: space-between;
  transform: translateY(-50%);
}
.slider-controls button {
  background: rgba(0, 0, 0, 0.5);
  color: white;
  border: none;
  padding: 10px 15px;
  cursor: pointer;
  font-size: 24px;
}
.slider-dots {
  text-align: center;
  margin-top: 10px;
  position: absolute;
  bottom: 10px;
  left: 50%;
}
.slider-dots span {
  display: inline-block;
  height: 12px;
  width: 12px;
  margin: 0 4px;
  background-color: #fff;
  border-radius: 50%;
  cursor: pointer;
}
.slider-dots span.active {
  background-color: #ce1f2e;
}
.cinema-accordion .title,
.cinema-accordion .sub-titles {
  font-size: 18px;
}

.cinema-accordion .tab-title {
  font-weight: bold;
  font-size: 11px;
  color: #000;
  text-align: center;
  text-transform: uppercase;
}
.cinema-accordion .accordion-title {
  cursor: pointer;
}
.cinema-accordion .tab-img {
  filter: grayscale(1);
}
.cinema-accordion .tab-img:not(:last-child) {
  padding-right: 05px;
}
.cinema-accordion .nav-link.active .tab-img {
  filter: grayscale(0);
}
.cinema-accordion .nav-link.active .tab-title {
  color: #ce1f2e;
}
.cinema-accordion .nav-link {
  padding: 0 0 10px 0;
  border: 1px solid #fff;
}
.cinema-accordion .nav-tabs {
  border-bottom: 1px solid #fff;
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
}
.cinema-accordion .nav-tabs .nav-link.active,
.cinema-accordion .nav-tabs .nav-item.show .nav-link,
.cinema-accordion .nav-tabs .nav-link:hover,
.cinema-accordion .nav-tabs .nav-link:focus {
  border-color: #fff;
}
.cinema-accordion .cine-addr .addr-loc {
  background-color: #e5e6e7;
}
.cinema-accordion .cine-addr .name {
  color: #434345;
  font-weight: bold;
  font-size: 21px;
}
.cinema-accordion .addr-map {
  background-color: #f8f9fa;
}
.cinema-accordion .addr-map .image {
  height: 100%;
  width: 100%;
}
.cinema-accordion .loc-img {
  width: 278px;
}
.cinema-accordion .cine-addr .desc {
  text-align: center;
  font-weight: 600;
  font-size: 13px;
}
.cinema-accordion .cine-addr .addr-btn {
  background-color: #ce1f2e;
  color: #fff;
  text-transform: uppercase;
  font-weight: 500;
  font-size: 13px;
  /* width: 140px; */
  border-radius: 0px;
  /* position: absolute;
  bottom: 05%;
  transform: translate(-50%, -50%); */
}

.cinema-accordion .accordion-title[aria-expanded="true"] .sub-titles {
  color: #ce1f2e;
  font-weight: bold;
}
@media (max-width: 768px) {
  .mobile_custom_margin {
    margin: 8rem 0 3rem 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/clubEmpire.vue